var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ 'background-color': _vm.isMobile ? 'white' : '#090e1d' }),attrs:{"id":"app"}},[(!_vm.isMobile)?_c('div',[_c('tab-bar',{style:({ backgroundColor: _vm.isScrolled ? 'rgba(9,14,29,0.8)' : '' })}),_c('router-view'),_c('app-footer')],1):_vm._e(),(_vm.isMobile)?_c('div',[_c('phone-tab'),_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }